import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';

import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';
import Modaladdwork from './Modaladdwork';
import Modaladdlist from './Modaladdlist';
import Modaladdworkedit from './Modaladdworkedit';

import NumberFormat from 'react-number-format';
import LoadingOverlay from 'react-loading-overlay';
import { Steps } from 'antd';
import Modaladdworkpay from './Modaladdworkpay';

const { Step } = Steps;





export default class Pageworkuser extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                loading:false,
            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getwork = this.getwork.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttographic = this.senttographic.bind(this);
            this.senttowait = this.senttowait.bind(this);
            
            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getwork (){
          this.setState({ loading:true})
            api.get('selectworksl.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ work: res.data,  loading: false })
            }) 
        }

       

        senttographic(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายกราฟฟิก",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttographic.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายกราฟฟิกสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }

           senttowait(event) {
            //  console.log(event.target.value);
              const date = new Date().toISOString().slice(0, 10)
              const gg = event.target.value
  
              Swal.fire({
                title: 'ยืนยัน',
                text: "รอดำเนินการ",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ตกลง',
               cancelButtonText: 'ยกเลิก'
              }).then((result) => {
                   if (result.isConfirmed) {
  
                      setTimeout(() => {
          
                          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                          datafrm.append("id", gg);
                          datafrm.append("datesent", date);
                          api.post("updatesenttowait.php",datafrm,{
                           headers: {
                                     'content-type': 'multipart/form-data'
                                    }
                                    })
                                            .then(res => {
                                               // console.warn(res);
                                               // console.log("response: ", res)
                                                if (res.status=== 200) {
              
                                              Swal.fire({
                                                title: 'ยืนยันรอดำเนินการสำเร็จ',
                                                icon: 'success',
                                              // showCancelButton: true,
                                                confirmButtonText: 'ตกลง',
                                              // cancelButtonText: 'No, keep it'
                                              }).then((result) => {
                                                this.getwork();
                                               // window.location.href = '/'
                                              })
                    
                                                }else{
                                                // window.location.href = '/'
                                                }
                    
                                            })
                    
                                }, 1000);
                    
                   // console.log('ok')
                    } else if (result.isDenied) {
                     // Swal.fire('Changes are not saved', '', 'info')
                    }
              })
           
             }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/sorlalum'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = '/sorlalum'
            } else {
  
            }
              this.getwork();
             // this.getstucount();
          }
        

 

    render() {
     // console.log(this.state.code)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;

//            const date = year + '-' + month + '-' + day;
     //console.log(date)
     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'รหัส',
            field: 'OLDID',
            sort: 'OLDID',
            width: 270
          },
          {
            label: 'รูป',
            field: 'PIC',
            sort: 'PIC'
            
          },
          {
            label: 'ชื่องาน',
            field: 'NAME',
            sort: 'NAME',
            width: 200
          },
           {
            label: 'วันที่เพิ่ม',
            field: 'DATES',
            sort: 'DATES',
            width: 200
          },
          {
            label: 'จำนวนเงิน',
            field: 'FACULTY',
            sort: 'FACULTY',
            width: 100
          },
          {
            label: 'ตรวจสอบ',
            field: 'check',
            sort: 'check',
            width: 100
          },
          {
            label: 'ยกเลิก',
            field: 'status',
            sort: 'status',
            width: 100
          }

        ],

        rows: [...this.state.work.map((data, i) => (
          {
             list: <>{i+1}</>,
             OLDID: <>{data.code_workorder}</>,
             PIC: <><img src={`https://lookmaenamping.com/sorlalumbackend/uploads/${data.example_workorder}`} alt="thumbnails" className="img-thumbnail "  width="60" /></>,
             NAME: <>{data.name_workorder}<div> <br/>
             <Steps size="small" current={data.statusfinish_workorder}>
             <Step title="รับงาน" description={data.dateadd_workorder.substring(0, 10)} />
             <Step title="กราฟฟิก" description={data.datesentgf_workorder} />
             <Step title="พิมพ์" description={data.datesentmf_workorder} />
             <Step title="ติดตั้ง" description={data.dateinstall_workorder } />
             <Step title="เสร็จสิ้น" description={data.datefinish_workorder} />
             <Step title="ชำระเงิน" description={data.datepayfinish_workorder} />
             </Steps>
              </div>
             
             </>,
             DATES: <>{data.dateadd_workorder}</>,
             FACULTY: <><NumberFormat value={data.price_workorder}  displayType={'text'} thousandSeparator={true}  /></>,
             check: <>
             {data.statusfinish_workorder === '5' ?<>
              <Modaladdworkpay id_workorder={data.id_workorder} getwork={this.getwork} />
              <Modaladdworkedit id_workorder={data.id_workorder} />
              </>:<>
              {data.statusfinish_workorder === '6' ?<>
             <p className="teal-text"><MDBIcon icon="dollar-sign" /> ชำระเงินแล้ว </p>
              </>:<>
               <Modaladdlist code={data.code_workorder} name_workorder={data.name_workorder} 	id_workorder={data.id_workorder}   /> 
                <Modaladdworkedit id_workorder={data.id_workorder} />
                {data.statussentgf_workorder == 1 ?<></>:<> <MDBBtn color="dark-green" size="sm" value={data.id_workorder} onClick={this.senttographic} ><MDBIcon icon="share-square" /> ส่งไปยังกราฟฟิก</MDBBtn></>}
              </>}
              
              </>}
         
             </>,
             status: <>
             {data.statusfinish_workorder === '6' ?<></>:<> <MDBBtn color="dark" size="sm" value={data.id_workorder} onClick={this.senttowait} ><MDBIcon icon="spinner" /> รอดำเนินการ</MDBBtn></>}
            
             </>
             

            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={20}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>
      

        return (
          <LoadingOverlay
          active={this.state.loading}
          spinner
          text='Loading your data...'
          >
                <MDBContainer fluid >
  <h2 className="font-weight-bold  text-center">  รายการใบสั่งงาน/ใบรับงาน</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้</p>
      <MDBRow >
          <div >
              <Modaladdwork getwork={this.getwork}/> 
          </div>
       
        <MDBCol md="12" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  รายการ</MDBCardTitle>
                    <br/>
                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     {persons}
                    </MDBCardBody>

                   
         </MDBCard>
        </MDBCol>


      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

    


                   
                    </MDBContainer>
                    </LoadingOverlay>     
     
        )
    }
}
